// extracted by mini-css-extract-plugin
export default {"siteFooter":"footer-siteFooter-yOwiOX","about":"footer-about-suZOiB","submitAnIssue":"footer-submitAnIssue-tqgGZs"};